module.exports = __webpack_public_path__ + "img/logo-igi.a0c69de.webp";